module.exports = __webpack_public_path__ + "static/media/Items in same color.23982cea.mp3";